import { Dated } from "../types";

function sortDateAscending<Element extends Dated>(
  current: Element,
  next: Element,
): number {
  const currentDate = new Date(current.date);
  const nextDate = new Date(next.date);

  return currentDate >= nextDate ? -1 : 1;
}

function sortDateDescending<Element extends Dated>(
  current: Element,
  next: Element,
): number {
  const currentDate = new Date(current.date);
  const nextDate = new Date(next.date);

  return currentDate >= nextDate ? 1 : -1;
}

export { sortDateAscending, sortDateDescending };
